export enum PostHogFlags {
  OffSiteListings = "off-site-listings",
  auction = "auction",
  bankNameMatching = "bankNameMatching",
  offsiteListings = "off-site-listings",
  ProveVerification = "prove-verification",
  UploadCustomVideos = "upload-custom-videos",
  AISearch = "ai-search",
}
